import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the STRING data type. Data items in shape models with the STRING
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class TextPositionDataItem extends AbstractDataItem<DataType.STRING> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof TextPositionDataItem.prototype.value ): IValidationError {
        return null;
    }
}
